import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StorefrontAnalyticsComponent } from './storefront-analytics.component';



const routes: Routes = [
    {
        path: '',
        component: StorefrontAnalyticsComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class StorefrontAnalyticsRoutingModule { }
